/**
 * Strips ANSI escape codes from text
 * Removes color codes and other terminal control sequences
 * @param text - Text containing ANSI escape codes
 * @returns Text with ANSI codes removed
 */
export const stripAnsiCodes = (text: string): string => {
  // Match ANSI escape sequences: ESC [ ... letter
  // Build regex dynamically to avoid ESLint control character warning
  const ESC = String.fromCharCode(0x1b);
  const ansiRegex = new RegExp(`${ESC}\\[[0-9;]*[a-zA-Z]`, "g");
  return text.replace(ansiRegex, "");
};
